import { render, staticRenderFns } from "./OfficeLocation.vue?vue&type=template&id=b53005c2&scoped=true&"
import script from "./OfficeLocation.vue?vue&type=script&lang=js&"
export * from "./OfficeLocation.vue?vue&type=script&lang=js&"
import style0 from "./OfficeLocation.vue?vue&type=style&index=0&id=b53005c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53005c2",
  null
  
)

export default component.exports